// extracted by mini-css-extract-plugin
module.exports = {"root":"spinner-large_root__hiY2K","rotate-spinner":"spinner-large_rotate-spinner__luyj_"};